import { FileModel, AttachmentModel } from "@interfaces/index";
import { TRANSACTION_FILE_EXTENSIONS } from "@utils/index";
import { FormFile, FileItem } from "@components/index";

export const TransactionReceipts = ({
  name,
  dataTestid,
  files,
  attachments = [],
  disabled,
  uploading,
  error,
  className,
  onSelectFiles,
  onRemoveFile,
  onRemoveAttachment,
}: {
  name: string;
  dataTestid?: string;
  files: FileModel[];
  attachments?: AttachmentModel[];
  disabled?: boolean;
  uploading?: boolean;
  error?: string;
  className?: string;
  onSelectFiles: (target: HTMLInputElement) => void;
  onRemoveFile?: (uuid: string) => void;
  onRemoveAttachment?: (uniqueId: string) => void;
}) => (
  <div className={className}>
    <FormFile
      name={name}
      dataTestid={dataTestid}
      error={error}
      accept={TRANSACTION_FILE_EXTENSIONS}
      disabled={disabled}
      uploading={uploading}
      onChange={(event) => {
        onSelectFiles(event.target as HTMLInputElement);
        event.preventDefault();
      }}
    />
    {!attachments.length && !files.length ? null : (
      <div className="mt-4 flex flex-col gap-y-4">
        {attachments.map((attachment) => (
          <FileItem
            key={attachment.uniqueId}
            file={attachment}
            onRemove={onRemoveAttachment}
          />
        ))}
        {files.map((file) => (
          <FileItem key={file.uuid} file={file} onRemove={onRemoveFile} />
        ))}
      </div>
    )}
  </div>
);
